import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { WATCH_IMAGES } from "@/lib/watchImages";
import WatchImage from "@/components/site/WatchImage";

const IMG = WATCH_IMAGES.midnightLinks.front;

export default function WhyItExists() {
  return (
    <section
      id="why"
      data-testid={TID.sectionWhy}
      className="relative py-28 sm:py-40 bg-gradient-to-b from-[#0C0F0A] via-[#161B14] to-[#1F382A]"
    >
      {/* Subtle gold filigree top accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-px bg-[#C5A059]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="lg:col-span-5 order-2 lg:order-1"
        >
          <div className="relative aspect-[4/5]">
            <div aria-hidden="true" className="absolute -inset-6 border border-[rgba(197,160,89,0.35)]" />
            <div aria-hidden="true" className="absolute -inset-1 bg-gradient-to-br from-[#C5A059]/15 via-transparent to-[#1F382A]/30" />
            <div className="relative w-full h-full p-4">
              <WatchImage
                src={IMG}
                alt="CLEMENT COURSE I — Midnight Links dial study"
                fallbackTitle="Midnight Links"
                fallbackSub="CRS-I · GC"
                testId="why-watch-image"
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.1, ease: "easeOut" }}
          className="lg:col-span-7 order-1 lg:order-2"
        >
          <div className="flex items-center gap-3">
            <span className="gold-rule" />
            <span className="overline">Chapter I · The House</span>
          </div>
          <h2 className="font-serif-display text-[#F5F2EB] font-light text-balance text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-6">
            Why{" "}
            <span className="italic text-[#C5A059]">the house</span> exists.
          </h2>
          <div className="mt-10 space-y-6 text-[#d6d3c6] text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              CLEMENT is a private watch house. Course I is the founding
              chapter — a mechanical golf timepiece designed for collectors
              who keep their best things in a safe, not on a charger.
            </p>
            <p>
              Wind, stroke counter, plays-like-yardage bezel,
              shot-adjustment. Hand-finished. Allocated to the registry.
              Released only when each piece meets the house&apos;s standards.
            </p>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            {[
              ["Mechanical", "Swiss-Made"],
              ["Analog", "No screens"],
              ["Allocation", "By registry"],
            ].map(([k, v]) => (
              <div key={k} className="border-t border-[rgba(197,160,89,0.5)] pt-4">
                <div className="overline">{k}</div>
                <div className="mt-2 text-[#F5F2EB] font-serif-display text-xl">
                  {v}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
